"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.Heading = void 0;
exports.NewsletterSignup = NewsletterSignup;
exports.NewsletterSignupContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@ux/button"));
var _textInput = _interopRequireDefault(require("@ux/text-input"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _core = require("@linaria/core");
var _text = _interopRequireDefault(require("@ux/text"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _index = require("../../elements/other/flexbox/index");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NewsletterSignupContainer = exports.NewsletterSignupContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NewsletterSignupContainer",
  class: "pl-nlj5ywa"
});
const Heading = exports.Heading = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "Heading",
  class: "pl-h15qjtii"
});
const Label = exports.Label = /*#__PURE__*/(0, _react2.styled)("label")({
  name: "Label",
  class: "pl-l1vzavur"
});
const Form = /*#__PURE__*/(0, _react2.styled)("form")({
  name: "Form",
  class: "pl-f44rthk"
});
const successMessage = "pl-s1ijap20";

/*
 * Use color variables
 * Need to beat out uxcore specificity somehow or don't use uxcore input
 */
const button = "pl-bi2jvw2";
const input = "pl-i14sprtv";
const stateMap = {
  success: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "checkmark",
    fill: "green"
  }),
  error: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "x",
    fill: "black"
  }),
  loading: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "ellipsis",
    fill: "black"
  })
};

/**
 * Footer Menu component.
 *
 * @param {Object} props React props
 * @param {string} props.heading Heading string
 * @param {string} props.placeholderText placeholder input string
 * @param {string} props.buttonText buttonText string
 * @param {string} props.submitUrl submitUrl string
 * @param {string} props.invalidInputText invalidInputText string
 * @param {string} props.failure failure string
 * @returns {React.ReactElement} Footer Legal layout
 * @public
 */
function NewsletterSignup({
  id,
  heading,
  placeholderText,
  buttonText,
  failure,
  success,
  submitUrl,
  invert,
  partial,
  invalidInputText,
  hideLabel = true,
  label = '',
  ...formElement
}) {
  const [inputValue, setInputValue] = (0, _react.useState)('');
  const [buttonState, setButtonState] = (0, _react.useState)('');
  const [errorMessage, setErrorMessage] = (0, _react.useState)(invalidInputText);
  const [succeeded, setSucceeded] = (0, _react.useState)(false);
  const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue);
  function handleSubmit(e) {
    e.preventDefault();
    setButtonState('loading');
    if (!isValid) {
      setButtonState('error');
      setErrorMessage(invalidInputText);
      return;
    }
    fetch(submitUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'text/plain'
      },
      credentials: 'include',
      body: JSON.stringify({
        EmailAddress: inputValue,
        PublicationId: 0,
        TemplateInfo: {
          TemplateTypeKey: 'GDWelcomeConfirmationSB',
          TemplateNamespaceKey: 'GDSHOP'
        }
      })
    }).then(res => {
      setInputValue('');
      if (res.ok) {
        setButtonState('success');
        setSucceeded(true);
      } else {
        setButtonState('error');
        setErrorMessage(failure);
      }
    });
  }
  const handleChange = e => {
    setInputValue(e);
    setButtonState('');
  };
  function getButton(state) {
    const buttonProps = {
      type: 'submit',
      className: `${button} ${state}`
    };
    if (state) {
      buttonProps.disabled = true;
      buttonProps.icon = stateMap[state];
    } else {
      buttonProps.disabled = false;
      buttonProps.text = buttonText;
    }
    return /*#__PURE__*/_react.default.createElement(_button.default, buttonProps);
  }
  return /*#__PURE__*/_react.default.createElement(NewsletterSignupContainer, {
    id: `id-${id}`,
    "data-cy": "newsletter-signup",
    "data-partial": partial
  }, /*#__PURE__*/_react.default.createElement(Heading, null, /*#__PURE__*/_react.default.createElement(Label, null, heading)), /*#__PURE__*/_react.default.createElement(Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_textInput.default, (0, _extends2.default)({
    id: `newsletter-formelement-${id}`,
    className: input,
    placeholder: placeholderText,
    errorMessage: isValid || !inputValue ? null : errorMessage,
    invalid: !!(!isValid && inputValue),
    value: inputValue,
    onChange: handleChange,
    "data-partial": partial || (invert ? 'dark1' : ''),
    hideLabel: hideLabel,
    label: label
  }, formElement)), getButton(buttonState)), succeeded && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "caption",
    text: success,
    className: successMessage
  }));
}
NewsletterSignup.propTypes = {
  id: _propTypes.default.string,
  heading: _propTypes.default.string,
  placeholderText: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  submitUrl: _propTypes.default.string,
  failure: _propTypes.default.string,
  success: _propTypes.default.string,
  label: _propTypes.default.string,
  hideLabel: _propTypes.default.bool,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  invalidInputText: _propTypes.default.string
};